/**
 * Purito Product Page Slider
 * Initializes Swiper for embedded thumbnails layout
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function initProductSlider() {
    const sliderElements = document.querySelectorAll('.product-single__slider');
    
    if (!sliderElements.length) return;
    
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded. Loading from CDN...');
      loadSwiperFromCDN();
      return;
    }
    
    sliderElements.forEach(initSlider);
  }
  
  function loadSwiperFromCDN() {
    // Load Swiper CSS
    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);
    
    // Load Swiper JS
    const swiperJS = document.createElement('script');
    swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    swiperJS.onload = function() {
      initProductSlider();
    };
    document.head.appendChild(swiperJS);
  }
  
  function initSlider(sliderElement) {
    const productId = sliderElement.getAttribute('data-product-id');
    
    // Swiper configuration
    const swiper = new Swiper(sliderElement, {
      // Core settings
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      
      // Autoplay
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      
      // Pagination (thumbnails)
      pagination: {
        el: sliderElement.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          const slides = sliderElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
          if (slides[index]) {
            const mediaId = slides[index].getAttribute('data-media-id');
            const bgImage = slides[index].querySelector('.product-single__slider-image');
            let bgUrl = '';
            
            if (bgImage) {
              // Try to get background-image from style attribute
              const styleAttr = bgImage.getAttribute('style');
              if (styleAttr && styleAttr.includes('background-image')) {
                bgUrl = styleAttr;
              }
            }
            
            return `<span class="${className}" data-media-id="${mediaId}" tabindex="0">
              <span style="${bgUrl}"></span>
            </span>`;
          }
          return `<span class="${className}"></span>`;
        }
      },
      
      // Lazy loading
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      },
      
      // Events
      on: {
        init: function() {
          // Add keyboard support to pagination bullets
          addBulletKeyboardSupport(sliderElement);
        },
        slideChange: function() {
          // Update active thumbnail
          updateActiveThumbnail(sliderElement, this.realIndex);
        }
      }
    });
    
    // Store swiper instance
    sliderElement.swiperInstance = swiper;
    
    // Add touch support for mobile
    if ('ontouchstart' in window) {
      sliderElement.classList.add('touch-enabled');
    }
  }
  
  function addBulletKeyboardSupport(sliderElement) {
    const bullets = sliderElement.querySelectorAll('.swiper-pagination-bullet');
    
    bullets.forEach((bullet, index) => {
      bullet.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (sliderElement.swiperInstance) {
            sliderElement.swiperInstance.slideTo(index);
          }
        }
      });
    });
  }
  
  function updateActiveThumbnail(sliderElement, activeIndex) {
    const bullets = sliderElement.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach((bullet, index) => {
      if (index === activeIndex) {
        bullet.classList.add('swiper-pagination-bullet-active');
        bullet.setAttribute('aria-current', 'true');
      } else {
        bullet.classList.remove('swiper-pagination-bullet-active');
        bullet.removeAttribute('aria-current');
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSlider);
  } else {
    initProductSlider();
  }
  
  // Re-initialize on Shopify section re-render
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(initProductSlider, 100);
    });
  }
  
})();
